// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-notification{bottom:7px;position:fixed;border:1px solid var(--accent);cursor:pointer;z-index:10}.add-notification:hover{opacity:.8}.add-notification:active{z-index:10}", ""]);
// Exports
module.exports = exports;
